import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

interface SaveSlotReplaceConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onReplace: () => void;
  showForcedDeployHint?: boolean;
  metadataUnverified?: boolean;
}

const SaveSlotReplaceConfirmDialog = ({
  open,
  onCancel,
  onReplace,
  showForcedDeployHint = false,
  metadataUnverified = false,
}: SaveSlotReplaceConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="dialogTitle" align="center" component="div">
          {metadataUnverified ? (
            <Trans i18nKey="slot.overwriteWarning.unverifiedTitle">Slot contents could not be verified</Trans>
          ) : (
            <Trans i18nKey="slot.overwriteWarning.title">Project already present in this slot</Trans>
          )}
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3, px: 3 }}>
        <Stack spacing={2}>
          <Typography variant="body1" component="p">
            {metadataUnverified ? (
              <Trans i18nKey="slot.overwriteWarning.unverifiedBody">
                Drive Unit slot metadata could not be read for this connection. Deploying to this slot may overwrite another project, even if the
                cached slot list looks empty or familiar.
              </Trans>
            ) : (
              <Trans i18nKey="slot.overwriteWarning.body">
                The slot you are currently working in already has a project. If you deploy to this slot, that project will be replaced and data may be
                lost if a backup is not saved.
              </Trans>
            )}
          </Typography>
          {showForcedDeployHint && (
            <Typography variant="body2" component="p">
              <Trans i18nKey="slot.overwriteWarning.forcedDeployHint">
                Confirming will continue the deploy action with this slot. Canceling keeps you in slot selection so you can choose a different slot.
              </Trans>
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'center', px: 2, py: 2 }}>
        <Stack direction="row" spacing={2}>
          <Button variant="text" onClick={onCancel}>
            <Trans i18nKey="slot.overwriteWarning.cancel">Cancel</Trans>
          </Button>
          <Button variant="contained" color="error" onClick={onReplace}>
            <Trans i18nKey="slot.overwriteWarning.confirm">Confirm</Trans>
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default SaveSlotReplaceConfirmDialog;
